var map = {
	"./cat (1).jpg": "564e",
	"./cat (2).jpg": "841a",
	"./changi.jpg": "99d1",
	"./hafary (1).jpg": "6f23",
	"./hafary (2).jpg": "3a84",
	"./hafary (3).jpg": "0019",
	"./hafary (4).jpg": "3470",
	"./hafary (5).jpg": "b967",
	"./kallang (1).jpg": "c594",
	"./kallang (2).jpg": "12f6",
	"./kallang (3).jpg": "1bc9",
	"./kallang (4).jpg": "4d9b",
	"./kallang (5).jpg": "f3a1",
	"./kurogane.jpg": "244e",
	"./ntu.jpg": "d7ea",
	"./star vista.jpg": "8138",
	"./wheelock.jpg": "60cb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ca96";